import * as React from 'react';
import {IonContent, IonIcon, IonPage} from '@ionic/react';
import Header from '../../../components/Header/Header';
import {useEffect, useState} from 'react';
import {Link} from '../../../interfaces/Link';
import {Link as RouterLink} from 'react-router-dom';
import firebaseService from '../../../services/firebaseService';
import iconService from '../../../services/iconService';
import './MorePages.css';

const MorePages: React.FC = () => {
    const [links, setLinks] = useState<Link[]>();

    useEffect(() => {
        const foundLinks: Link[] = [];
        firebaseService.getLinks().then(res => {
            res.docs.forEach(doc => {
                const foundLink = doc.data() as Link;
                foundLink.name = doc.id;
                foundLink.icon = iconService.getIcon(foundLink.icon);
                foundLinks.push(foundLink);
            });
            foundLinks.sort((a, b) => {
                return a.order - b.order;
            });
            setLinks(foundLinks);
        })
    }, []);

    return (
        <IonPage>
            <Header title="App Center" />
            <IonContent fullscreen className="page-content">
                <div className="page-body">
                    <div className="page-body__meta">
                        <h1 className="page-body__title">App Center</h1>
                        <span>{links ? `${links.length} apps` : 'Loading apps'}</span>
                    </div>

                    {/* RouterLink rather than <a>: an anchor would reload the
                        whole app instead of routing to the page. */}
                    <div className="app-grid">
                        {links?.map((link, index) => (
                            <RouterLink
                                className="app-tile"
                                to={"/AppCenter/" + link.name}
                                key={index}
                            >
                                <span className="app-tile__icon" aria-hidden="true">
                                    <IonIcon icon={link.icon} />
                                </span>
                                <span className="app-tile__name">{link.name}</span>
                            </RouterLink>
                        ))}
                    </div>

                    {links && links.length === 0 && (
                        <p className="app-empty">No apps are available for your account yet.</p>
                    )}
                </div>
            </IonContent>
        </IonPage>
    );
};

export default MorePages;
